import { IMediaListModel } from "@nf/common";
import { NextSeo } from "next-seo";
import Head from "next/head";

export interface IPlaylistSEOProps {
  media: IMediaListModel;
}

export const PlaylistSEO = ({ media }: IPlaylistSEOProps) => {
  const metaTitle = media.Seo?.Title;

  if (!metaTitle) {
    return null;
  }

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
      </Head>

      <NextSeo title={metaTitle} titleTemplate="%s" />
    </>
  );
};

export default PlaylistSEO;
